import React from 'react';

const BedroomPlaceholder = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={108} height={77} fill="none" {...props}>
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M1 75.32h106"
    />
    <path
      fill="#EAEAEA"
      stroke="#959595"
      d="M63.342 45.455v14.718a137.057 137.057 0 0 1-53.423 0V45.454c0-1.215 1.128-2.537 2.583-2.814a137.111 137.111 0 0 1 48.256 0c1.455.277 2.584 1.6 2.584 2.815Z"
    />
    <path
      fill="#959595"
      stroke="#959595"
      d="M12.656 43.126h-.004a4.47 4.47 0 0 0-1.607.606c.103-.16.23-.315.378-.463a3.37 3.37 0 0 1 1.784-.913 148.693 148.693 0 0 1 46.846 0c.698.12 1.33.463 1.784.913.15.148.275.304.378.463a4.471 4.471 0 0 0-1.606-.605h-.005a154.669 154.669 0 0 0-47.948 0Z"
    />
    <mask id="a" fill="#fff">
      <path d="M31.955 56.747a81.54 81.54 0 0 1-16.01 0 2.408 2.408 0 0 1-2.158-2.204 18.422 18.422 0 0 1 0-2.944 2.408 2.408 0 0 1 2.158-2.204 81.54 81.54 0 0 1 16.01 0 2.408 2.408 0 0 1 2.158 2.204c.078.984.078 1.96 0 2.944a2.408 2.408 0 0 1-2.158 2.204Z" />
    </mask>
    <path
      fill="#E4E4E4"
      d="M31.955 56.747a81.54 81.54 0 0 1-16.01 0 2.408 2.408 0 0 1-2.158-2.204 18.422 18.422 0 0 1 0-2.944 2.408 2.408 0 0 1 2.158-2.204 81.54 81.54 0 0 1 16.01 0 2.408 2.408 0 0 1 2.158 2.204c.078.984.078 1.96 0 2.944a2.408 2.408 0 0 1-2.158 2.204Z"
    />
    <path
      fill="#959595"
      d="m31.955 56.747-.098-.995.098.995Zm-16.01 0 .098-.995-.098.995Zm-2.158-2.204.997-.08-.997.08Zm0-2.944.997.08-.997-.08Zm2.158-2.204-.098-.996.098.996Zm16.01 0-.098.995.098-.995Zm2.158 2.204-.997.08.997-.08Zm0 2.944-.997-.08.997.08Zm-2.256 1.21a80.536 80.536 0 0 1-15.814 0l-.196 1.99c5.39.531 10.817.531 16.207 0l-.197-1.99Zm-15.814 0a1.407 1.407 0 0 1-1.259-1.29l-1.993.16a3.408 3.408 0 0 0 3.056 3.12l.196-1.99Zm-1.259-1.29a17.44 17.44 0 0 1 0-2.784l-1.993-.16a19.45 19.45 0 0 0 0 3.103l1.993-.159Zm0-2.784a1.408 1.408 0 0 1 1.26-1.29l-.197-1.99a3.408 3.408 0 0 0-3.056 3.12l1.993.16Zm1.26-1.29a80.536 80.536 0 0 1 15.813 0l.197-1.99a82.547 82.547 0 0 0-16.207 0l.196 1.99Zm15.813 0c.671.067 1.205.61 1.26 1.29l1.993-.16a3.407 3.407 0 0 0-3.056-3.12l-.197 1.99Zm1.26 1.29c.073.93.073 1.853 0 2.784l1.993.16a19.427 19.427 0 0 0 0-3.103l-1.994.159Zm0 2.784a1.407 1.407 0 0 1-1.26 1.29l.197 1.99a3.407 3.407 0 0 0 3.056-3.12l-1.994-.16Z"
      mask="url(#a)"
    />
    <path
      fill="#E4E4E4"
      stroke="#959595"
      d="M31.73 55.07a76.511 76.511 0 0 1-15.56 0m15.56 0-17.093-.566-.008-.108c.422.37.953.614 1.542.675m15.559 0a2.76 2.76 0 0 0 1.541-.675m-1.541.675 1.541-.675m-17.1.675.05-.498m-.05.498.05-.498m0 0c5.14.525 10.318.525 15.458 0l-17.088-.958c.38.528.962.89 1.63.958Zm17.05-.177a13.09 13.09 0 0 1-.008.108c-.071.932-.773 1.658-1.635 1.746a75.525 75.525 0 0 1-15.355 0c-.862-.088-1.564-.814-1.636-1.746l18.634-.108Z"
      opacity={0.47}
    />
    <path
      fill="#E4E4E4"
      stroke="#959595"
      d="M15.896 50.107a82.044 82.044 0 0 1 16.109 0l-.05.497c.667.066 1.25.403 1.644.899l-17.703-1.396Zm0 0a2.882 2.882 0 0 0-1.017.295c.298-.281.685-.467 1.115-.51a81.052 81.052 0 0 1 15.912 0c.43.043.818.229 1.115.51l-17.125-.295Zm18.273 2.697a18.102 18.102 0 0 0-.056-1.205 2.398 2.398 0 0 0-.044-.302l.1 1.508Z"
      opacity={0.5}
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M31.955 56.747a81.54 81.54 0 0 1-16.01 0 2.408 2.408 0 0 1-2.158-2.204 18.422 18.422 0 0 1 0-2.944 2.408 2.408 0 0 1 2.158-2.204 81.54 81.54 0 0 1 16.01 0 2.408 2.408 0 0 1 2.158 2.204c.078.984.078 1.96 0 2.944a2.408 2.408 0 0 1-2.158 2.204Z"
    />
    <path
      fill="#E4E4E4"
      stroke="#959595"
      d="M57.266 56.25a81.038 81.038 0 0 1-15.912 0 1.907 1.907 0 0 1-1.708-1.747 17.919 17.919 0 0 1 0-2.864 1.908 1.908 0 0 1 1.708-1.747 81.038 81.038 0 0 1 15.912 0c.914.09 1.635.828 1.709 1.747.076.957.076 1.907 0 2.864a1.908 1.908 0 0 1-1.709 1.747Z"
    />
    <path
      fill="#E4E4E4"
      stroke="#959595"
      d="M41.678 55.07a73.634 73.634 0 0 0 15.264 0 2.691 2.691 0 0 0 1.5-.659l-.007.094c-.07.939-.763 1.658-1.596 1.745a72.636 72.636 0 0 1-15.057 0m-.104-1.18.052-.497m-.052.497.052-.497m-.052.497a2.691 2.691 0 0 1-1.5-.659m1.552.162c5.041.525 10.12.525 15.16 0m-15.16 0a2.244 2.244 0 0 1-1.59-.944c.008.26.02.521.038.782m0 0 .007.094c.071.939.763 1.658 1.597 1.745m0 0-.052.498.052-.498Z"
      opacity={0.47}
    />
    <path
      fill="#E4E4E4"
      stroke="#959595"
      d="M41.256 50.107a82.044 82.044 0 0 1 16.108 0H41.257Zm0 0a2.883 2.883 0 0 0-1.017.295c.298-.281.685-.467 1.115-.51a81.054 81.054 0 0 1 15.912 0c.43.043.818.229 1.115.51l-17.125-.295Zm18.273 2.697a18.17 18.17 0 0 0-.056-1.205 2.416 2.416 0 0 0-.044-.302l.1 1.508Z"
      opacity={0.5}
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M57.315 56.747a81.541 81.541 0 0 1-16.01 0 2.407 2.407 0 0 1-2.157-2.204 18.422 18.422 0 0 1 0-2.944 2.407 2.407 0 0 1 2.157-2.204 81.541 81.541 0 0 1 16.01 0 2.408 2.408 0 0 1 2.158 2.204c.078.984.078 1.96 0 2.944a2.408 2.408 0 0 1-2.158 2.204Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M63.842 60.583a137.549 137.549 0 0 1-54.423 0V45.455c0-1.492 1.336-2.993 2.992-3.307a137.61 137.61 0 0 1 48.438 0c1.656.314 2.993 1.815 2.993 3.306v15.129Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M62 57.133a168.343 168.343 0 0 1-50 0V46.745c0-1.023 1.228-2.054 2.75-2.27a168.562 168.562 0 0 1 44.5 0c1.522.216 2.75 1.246 2.75 2.27v10.388Z"
    />
    <path
      fill="#C8C8C8"
      stroke="#959595"
      d="M8.587 61.214a4.345 4.345 0 0 1 4.315-3.844h47.456c2.23 0 4.068 1.68 4.316 3.844H8.587Z"
    />
    <path fill="#DADADA" stroke="#959595" d="M8.558 61.214v-1.422h56.144v1.422H8.558Z" opacity={0.38} />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M65.202 61.714H8.058a4.844 4.844 0 0 1 4.844-4.844h47.456a4.844 4.844 0 0 1 4.844 4.844Z"
    />
    <path
      fill="#AA7D5E"
      stroke="#959595"
      d="M65.76 73.855H7.5V62.923a.71.71 0 0 1 .71-.71H65.05a.71.71 0 0 1 .71.71v10.932Z"
    />
    <path
      fill="#EAEAEA"
      stroke="#959595"
      d="M65.76 73.855H7.5V62.923a.71.71 0 0 1 .71-.71H65.05a.71.71 0 0 1 .71.71v10.932Z"
    />
    <path fill="#DADADA" stroke="#959595" d="M7.5 73.855v-.763h58.26v.763H7.5Z" opacity={0.96} />
    <path fill="#959595" stroke="#959595" d="M7.51 62.801a.71.71 0 0 1 .7-.587H65.05a.71.71 0 0 1 .7.587H7.51Z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M66.26 74.355H7V62.923c0-.668.542-1.21 1.21-1.21H65.05c.668 0 1.21.542 1.21 1.21v11.432Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M64 74H10v-8.139c0-.476.493-.861 1.102-.861h51.796c.609 0 1.102.385 1.102.861V74ZM32.63 27.884H16v2.418h16.63v-2.418ZM20.99 15.225h-3.528v12.659h3.528V15.225Z"
    />
    <path fill="#E2E2E2" stroke="#959595" d="M17.962 27.384V15.725h2.528v11.659h-2.528Z" opacity={0.38} />
    <path fill="#E2E2E2" stroke="#959595" d="M21.49 27.384V12.5h2.527v14.884H21.49Z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M24.517 12H20.99v15.884h3.527V12Z"
    />
    <path fill="#E2E2E2" stroke="#959595" d="m25.5 27.16.017-11.66 2.377.004-.016 11.659-2.377-.004Z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M28.395 15.005 25.018 15 25 27.659l3.377.004.018-12.658Z"
    />
    <path fill="#F9F9F9" stroke="#959595" d="M41.5 29.392V18.5h14.881v10.892H41.5Z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M56.881 18H41v11.892h15.881V18Z"
    />
    <path fill="#E4E4E4" stroke="#959595" d="M43.163 20.163h11.556v7.567H43.163v-7.567Z" />
    <path fill="#D0D0D0" stroke="#959595" d="M73.006 72.06V53.409h20.467v18.653H73.006Z" />
    <path
      fill="#F3F3F3"
      stroke="#959595"
      d="M74.82 55.115H91.66v6.37H74.82v-6.37ZM74.82 63.983H91.66v6.37H74.82v-6.37Z"
    />
    <path fill="#ECECEC" stroke="#959595" d="M74.82 63.983H91.66v.128H74.82v-.128Z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M93.973 52.908H72.506v19.653h21.467V52.908Z"
    />
    <path fill="#ECECEC" stroke="#959595" d="M74.82 55.115H91.66v.128H74.82v-.128Z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M92.159 61.985v-7.37H74.32v7.37H92.16ZM92.159 70.853v-7.37H74.32v7.37H92.16ZM78.15 40.682v-.85c0-3.232 2.459-5.852 5.492-5.852 3.034 0 5.493 2.62 5.493 5.851V50.71"
    />
    <path fill="#959595" stroke="#959595" d="M84.42 52.408v-1.721h6.534v1.721H84.42Z" />
    <path fill="#959595" stroke="#959595" d="M84.42 50.915v-.228h6.534v.228H84.42Z" opacity={0.44} />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M91.454 50.187H83.92v2.721h7.534v-2.721Z"
    />
    <path
      fill="#F3F3F3"
      stroke="#959595"
      d="M81.895 43.558c0 .425-.038.837-.11 1.23h-7.27a6.848 6.848 0 0 1-.11-1.23c0-1.452.445-2.748 1.142-3.67.696-.922 1.621-1.447 2.603-1.447.981 0 1.906.525 2.603 1.447.697.922 1.142 2.218 1.142 3.67Z"
    />
    <path
      fill="#959595"
      stroke="#959595"
      d="M78.15 38.441c.064 0 .129.003.194.008.336.75.53 1.62.53 2.55 0 1.508-.509 2.85-1.301 3.79h-3.058a6.848 6.848 0 0 1-.11-1.23c0-1.453.445-2.75 1.142-3.671.696-.922 1.621-1.447 2.603-1.447Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M82.189 45.289a7.293 7.293 0 0 0 .206-1.73c0-3.103-1.9-5.618-4.245-5.618s-4.246 2.515-4.246 5.617c0 .604.073 1.185.207 1.73h8.078ZM86 58h-5v1h5v-1ZM86 67h-5v1h5v-1Z"
    />
    <path fill="#959595" stroke="#959595" d="m79.97 73.06-1.543 1.76h-3.506v-1.76h5.048Z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M78.654 75.32H74.42v-2.76h6.652l-2.42 2.76Z"
    />
    <path fill="#959595" stroke="#959595" d="M91.558 73.06v1.76h-3.506l-1.542-1.76h5.048Z" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M87.825 75.32h4.233v-2.76h-6.652l2.42 2.76Z"
    />
    <path
      fill="#959595"
      stroke="#959595"
      d="M82.675 40.377a.3.3 0 0 1 .019-.035.306.306 0 0 1-.033.072.305.305 0 0 1 .014-.037Z"
      opacity={0.44}
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m46.459 26.323 5.102-5.102M45.674 23.946l2.3-2.3M25.012 18.252l3.377-.062M17.462 18.068h3.528"
    />
    <path
      fill="#959595"
      d="M84.342 3.494a.2.2 0 0 0-.245-.143l-2.544.676a.2.2 0 0 0-.142.244l.077.293a.2.2 0 0 0 .245.142l1.211-.322a.2.2 0 0 1 .233.277l-1.063 2.307a.2.2 0 0 0-.012.135l.075.284a.2.2 0 0 0 .245.142l2.654-.706a.2.2 0 0 0 .142-.244l-.077-.292a.2.2 0 0 0-.245-.143l-1.32.35a.2.2 0 0 1-.234-.277l1.06-2.309a.2.2 0 0 0 .012-.134l-.072-.28Zm-7.603.014c.147-.15.009-.406-.191-.342a10.277 10.277 0 0 0-6.735 6.959 10.278 10.278 0 0 0 7.072 12.698 10.278 10.278 0 0 0 11.038-3.731c.126-.168-.072-.383-.261-.291a9.544 9.544 0 0 1-6.747.589 9.544 9.544 0 0 1-6.567-11.791 9.543 9.543 0 0 1 2.39-4.091Zm10.9 4.928a.2.2 0 0 0-.28.032l-.263.329a.2.2 0 0 0 .032.281l1.225.976a.2.2 0 0 1-.083.352l-2.978.625a.2.2 0 0 0-.116.071l-.239.3a.2.2 0 0 0 .032.282l2.553 2.035a.2.2 0 0 0 .281-.031l.263-.33a.2.2 0 0 0-.032-.28l-1.327-1.058a.2.2 0 0 1 .083-.352l2.978-.624a.2.2 0 0 0 .116-.072l.24-.3a.2.2 0 0 0-.033-.281L87.64 8.436Zm-6.022 1.456a.2.2 0 0 0-.213-.186l-4.356.29a.2.2 0 0 0-.186.212l.046.704a.2.2 0 0 0 .213.187l2.323-.155a.2.2 0 0 1 .175.316l-2.5 3.473a.2.2 0 0 0-.038.13l.041.61a.2.2 0 0 0 .213.186l4.53-.298a.2.2 0 0 0 .187-.213l-.046-.704a.2.2 0 0 0-.213-.187l-2.498.168a.2.2 0 0 1-.176-.317l2.501-3.473a.2.2 0 0 0 .038-.13l-.04-.613Z"
    />
  </svg>
);

export default BedroomPlaceholder;
